import axios from 'utility/axios';
import {toSlug} from 'utility/string';
import {GET_COUNTY, GET_COUNTIES} from 'utility/endpoints';
import getNested from 'utility/getNested';

export const fetchCounty = async ({county, state}) => {
  try{
    let url = `${GET_COUNTY}/${toSlug(state)}/${toSlug(county)}`
    const res = await axios.get(url)
    return getNested(res, 'data')
  }catch(err){
    console.log("Error: ", err)
  }
};

export const fetchCounties = async () => {
  try{
    let url = GET_COUNTIES
    const res = await axios.get(url);
    return getNested(res, 'data')
  }catch(err){
    console.log("Error: ", err)
  }
}